import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as CheckoutStore from '../../store/Checkout';
import { ApplicationState } from '../../store';

function CheckoutPartnerHeaderSteps(props: {
    checkoutState: CheckoutStore.IState
}) {
    return (<ul className="header-tracker">
        {(props.checkoutState.availableImpactPartners || []).map((partner, index) => {
            return (<li className={(props.checkoutState.currentImpactPartner && props.checkoutState.currentImpactPartner.Id !== partner.Id) ? "track-item" : "track-item active current-page"}>
                <div className="tracker-item-circle">{(index + 1)}</div>
                <span>{partner.Name}</span>
            </li>)
        })}
    </ul>);
}

export default connect((state: ApplicationState) => ({
    checkoutState: state.checkout
}),
    (dispatch, getState) => ({
    }))(CheckoutPartnerHeaderSteps);